
export enum ModalType {
  FULLSCREEN = 'fullscreen',
  ALERT = 'alert',
  PROMPT = 'prompt'
}